import React, { Component } from 'react';
import './Landing.css';
import Modal from 'react-modal';

import headphones from '../../assets/img/headphones.png';
import cart from '../../assets/img/cart.png';
import menu from '../../assets/img/menu.png';

import { Route } from 'react-router-dom';
import Coordinates from '../Coordinates/Coordinates';
import OuterLocation from '../OuterLocation/OuterLocation';
Modal.setAppElement("#root");
class Landing extends Component {
    state = {
        modalIsOpen: false
    }

    setModal(value) {
        this.setState({ modalIsOpen: value });
    }

    render() {
        return (
            <div>
                <div className="icons">
                    <img src={menu} alt="menuIcon" width="30" height="30" />
                    <img src={cart} alt="cartIcon" width="30" height="30" />
                </div>
                <h1 className="companyTitle">danaz.com</h1>
                <p className="tagLine">Buy and sell anything!</p>
                <img src={headphones} alt="headphones" width="300" />
                <h2 className="strikePrice"><strike>&#8377; 10,999.00/-</strike></h2>
                <h2>&#8377; 8,999.00/-</h2>
                <div className="purchaseButtons">
                    <button className="buyNow" onClick={() => this.setModal(true)}><b>Buy Now</b></button>
                    <button className="cart"><b>Add to Cart</b></button>
                </div>
                <h3>The Trendsetter H20 Headphones</h3>
                <p className="desc">Choose what you hear with superior noise cancellation that
                enhances sound quality while blocking outside distractions.
                Push the boundaries and find your flow with fully immersive
                surround sound.</p>
                <Modal isOpen={this.state.modalIsOpen} onRequestClose={() => this.setModal(false)}
                    style={
                        {
                            overlay: {
                                backgroundColor: 'grey',
                            }
                        }
                    }>
                    <h2>Delivery Address</h2>
                    <input className="deliveryAddress" placeholder="City, Region, ZIP" />
                    <br />
                    <br />
                    <button className="next">Next</button>
                    <p className="or">OR</p>
                    <h3>Add Address via <span className="thegana">Thegana</span></h3>
                    <p>I want this delivered to: </p>
                    <p><a href="/currentLocation"><button className="currentLocation">My Current Location</button></a></p>
                    <p><a href="/outerLocation"><button className="outerLocation">A Different Location</button></a></p>
                    <br /><br /><br />
                    <button className="cancel" onClick={() => this.setModal(false)}>Cancel</button>
                </Modal>
                <Route path="/currentLocation" exact component={Coordinates} />
                <Route path="/outerLocation" exact component={OuterLocation} />
            </div>
        );
    }
}

export default Landing;
